import { Button, Tag, Tooltip } from 'antd';
import React from 'react';
import { EditOutlined } from '@ant-design/icons';

export const AdministrationCompanyColumn = (handleEdit: (record: any) => void) => [
  
  {
    title: 'Client Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className="ellipsis-cell">{text}</div>
      </Tooltip>
    )
  },
  {
    title: 'Tip de client',
    dataIndex: 'type',
    key: 'type',
    hidden: false,
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className="ellipsis-cell">{text}</div>
      </Tooltip>
    )
  },
  {
    title: 'Denunmire',
    dataIndex: 'name',
    key: 'name',
    hidden: false,
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className="ellipsis-cell">{text}</div>
      </Tooltip>
    )
  },
  {
    title: 'Manager',
    dataIndex: 'accountManager',
    key: 'accountManager',
    width:150,
    render: (record: { name: any }) => (
      <Tooltip title={record ? record?.name : '-'}>
        <div className="ellipsis-cell">{record ? record?.name : '-'}</div>
      </Tooltip>
    ),
    hidden: false,
  },
  {
    title: 'Administrator',
    dataIndex: 'leadership',
    key: 'leadership',
    hidden: false,
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className="ellipsis-cell">{text}</div>
      </Tooltip>
    )
  },
  {
    title: 'Adresa',
    dataIndex: 'address',
    key: 'address',
    hidden: false,
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className="ellipsis-cell">{text}</div>
      </Tooltip>
    )
  },
  {
    title: 'CNP',
    dataIndex: 'cnp',
    key: 'cnp',
    width: 200,
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
    hidden: false,
  },
  {
    title: 'CUI',
    dataIndex: 'cui',
    key: 'cui',
    width: 200,
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
    hidden: false,
  },
  {
    title: 'Banca',
    dataIndex: 'bank',
    key: 'bank',
    hidden: false,
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className="ellipsis-cell">{text}</div>
      </Tooltip>
    )
  },
  {
    title: 'IBAN',
    dataIndex: 'bankAccount',
    key: 'bankAccount',
    hidden: false,
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className="ellipsis-cell">{text}</div>
      </Tooltip>
    )
  },
  {
    title: 'Numar inregistrare',
    dataIndex: 'registrationNumber',
    key: 'registrationNumber',
    width: 200,
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
    hidden: false,
  },
  {
    title: 'Descrierea activitatii',
    dataIndex: 'activityDescription',
    key: 'activityDescription',
    width: 200,
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
    hidden: false,
  },
  {
    title: 'Telefon',
    dataIndex: 'phone',
    key: 'phone',
    render: (_: any, record: { phone: any[] }) => (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
      >
        {record?.phone?.map((item, index) => (
          <Tag color={'blue'} key={`phone_${index}`}>
            {item}
          </Tag>
        ))}
        {!record?.phone && <Tag color={'blue'}>-</Tag>}
      </div>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: (_: any, record: any) => (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
      >
        {record?.email?.map((item: any, index: any) => (
          <Tag color={'blue'} key={`email_${index}`}>
            {item}
          </Tag>
        ))}
        {!record?.email && <Tag color={'blue'}>-</Tag>}
      </div>
    ),
  },
  {
    title: 'Adresa web',
    dataIndex: 'webAddress',
    key: 'webAddress',
    width: 200,
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
    hidden: false,
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: any) => (
      <>
      <Tooltip title='Modifica'>
        <Button className='modify-button' icon={<EditOutlined />} onClick={() => handleEdit(record)}/>
        </Tooltip>
      </>
    ),
    width: 120,
    hidden: false,
    fixed:'right'
  },
  
];
